<template>  
  <modal v-model="show"
         max-width="500"
         :has-padding="false">         

    <div :key="data.id">
        <app-ip-firewall-form-body ref="body"
                           v-model="data"
                           @input="input"
                           @valid="save"></app-ip-firewall-form-body>
        <div class="card-footer">
            <button class="btn btn-primary btn-round" @click="validate()">
                {{$t('message.generics.message.save')}}
            </button>
        </div>
    </div>
  </modal>   
</template>

<script>
    import AppIpFirewallFormBody from './components/IpFirewallFormBody'
    import EventBus from '@packages/event-bus/index'
    import Modal from "@/components/generic/Modal";

    export default {
        components: {
            AppIpFirewallFormBody,
            Modal
        },

        data() {
            return {
                show: false,
                data : {}
            }
        },

        props: {
            dataActivatorText: {
                type: String,
                required: true
            }
        },

        computed: {
        },

        methods: {
            input(value) {
                this.data = value
            },
            reset(deviceId){
                this.show = true
                this.data = {}
                this.data.deviceId = deviceId
            },
            validate() {
                this.$refs.body.validate()
            },
            async save() {
                if (this.data.id) {
                    await this.$api.ipfirewall.update(this.data)
                } else {
                    await this.$api.ipfirewall.create(this.data)
                }

                EventBus.$emit(`LOAD_IPFIREWALL`)
                this.show = false
            },

        },
        mounted() {
            EventBus.$on('EDIT_IPFIREWALL', this.edit)
            EventBus.$on('CREATE_IPFIREWALL', this.reset)
        },
        beforeDestroy() {
            EventBus.$off('EDIT_IPFIREWALL', this.edit)
            EventBus.$off('CREATE_IPFIREWALL', this.reset)
        },
    }
</script>

<style lang="scss" scoped>

    .card-footer {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 15px;

        .btn {
            margin: 15px;
        }
    }

    .modal-round .v-card .card-body {
        min-height: 160px;
    }
</style>
